import { LISTING_TYPE_HUMAN_NAME_MAP_TITLE } from './listingTypeHumanNameMapTitle';

export const LISTING_TYPE_HUMAN_NAME_MAP_COUNTS = {
  ...LISTING_TYPE_HUMAN_NAME_MAP_TITLE,
  VOLOP: getText('Volunteer Opportunity'),
  GRAD_PROGRAM: getText('Grad Program'),
};
